export default "__VITE_ASSET__cd28be41__"